import React, { useRef } from "react"
import { connect } from "react-redux"
import classNames from "classnames"
import { Picky } from "react-picky"
import { Form as BootstrapForm } from "react-bootstrap"
import { FormikProps } from "formik/dist/types"
import {
  getAvailableMissions,
  isMultiMissionsAvailable,
} from "../../../helpers/configurationHelper"
import {
  convertLastShapeToPolygonTypeAction,
  removeLastShapeAction,
} from "../../../state/geoMap/actions"
import { setMissionAction, setMultiMissionAction } from "../../../state/application/actions"
import { validateShapeWithNotification } from "../../../state/geoMap/dispatchActions"
import {
  getPlaceholderForSelectField,
  hasBeenFilled,
} from "../../../helpers/dynamicFormHelper"
import { AdvancedSearchConfigurationsType } from "../../../types/configurations"
import { ShapeType } from "../../../types/shape"
import translations from "../../../translations"
import {AppParametersType} from "../../../types/app";

interface PropsType {
  mainInputConfigurations: any,
  configurations: AdvancedSearchConfigurationsType,
  scopeConfigurationFields: string,
  selectedArea: ShapeType,
  loadingInitialData: boolean,
  setMissionActionHandler: any,
  setMultiMissionActionHandler: any,
  removeLastShapeActionHandler: any,
  disabled: boolean,
  formProps: FormikProps<any>,
  language: string,
  convertLastShapeToPolygonType?: any,
  multiMission?: boolean,
  appParameters: AppParametersType
}

const MissionField = (props: PropsType) => {
  const {
    mainInputConfigurations,
    scopeConfigurationFields,
    configurations,
    selectedArea,
    loadingInitialData,
    setMissionActionHandler,
    setMultiMissionActionHandler,
    removeLastShapeActionHandler,
    disabled,
    formProps,
    language,
    convertLastShapeToPolygonType,
    multiMission = false,
    appParameters
  } = props

  const { values, touched, errors, setFieldValue, resetForm } = formProps

  const missionRef: any = useRef(null)

  const missionOptions = getAvailableMissions(configurations, values).map(
    (mission) => {
      return {
        label: mission.description,
        value: mission.code,
      }
    }
  )

  const value = missionOptions.filter((m) => values.missions?.includes(m.value))
  const isInputDisabled =
    (disabled && hasBeenFilled(value)) || loadingInitialData

  return (
    <div ref={missionRef} className="row mx-0 mb-3 pb-3">
      <BootstrapForm.Label className="m-0 px-0 col-3 d-flex">
        <svg className="label-icon">
          <use xlinkHref="#mission-icon" fill="#9A9BA6" />
        </svg>
        <span>
          *
          {translations("missionSearchFilters", language)}
        </span>
      </BootstrapForm.Label>
      <BootstrapForm.Group
        className={classNames("col-9 m-0 pr-0", {
          "is-invalid": !!errors.missions && !!touched.missions,
        })}
      >
        <Picky
          id="picky"
          className="mission-multiselect"
          numberDisplayed={1}
          options={missionOptions}
          valueKey="value"
          labelKey="label"
          keepOpen={false}
          // MOD: "multiple" era commentato
          // @MAPITALY: ALEX1 Multimission
          multiple={
            (isMultiMissionsAvailable(configurations)) ||
             multiMission

          }
          includeSelectAll={
            (isMultiMissionsAvailable(configurations)) ||
            multiMission
          }
          placeholder={getPlaceholderForSelectField(language)}
          allSelectedPlaceholder={translations("allSelected", language)}
          manySelectedPlaceholder={translations("manySelected", language)}
          selectAllText={translations("selectAllSearchFilters", language)}
          value={value}
          onChange={(input) => {
            const missionsSelected = Array.isArray(input) ? input : [input]
            const missionCodesSelected = missionsSelected.map((m) => m["value"])
            resetForm()
            for (const key of Object.keys(mainInputConfigurations)) {
              if (key !== "missions") {
                setFieldValue(key, values[key])
              }
            }
            setFieldValue("missions", missionCodesSelected)
            const bypassInscribedPolygon = false
            if (missionsSelected.length > 1) {
              setMultiMissionActionHandler(missionCodesSelected)
            } else {
              setMissionActionHandler(missionCodesSelected)
            }
            validateShapeWithNotification(
              configurations,
              appParameters,
              scopeConfigurationFields,
              { ...values, missions: missionCodesSelected },
              selectedArea,
              language,
              bypassInscribedPolygon
            ).catch(() => {
              removeLastShapeActionHandler()
            })
          }}
          onOpen={() => {
            if (missionRef) {
              missionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              })
            }
          }}
          dropdownHeight={140}
          disabled={isInputDisabled}
        />
        <BootstrapForm.Control.Feedback type="invalid">
          {errors.missions}
        </BootstrapForm.Control.Feedback>
      </BootstrapForm.Group>
    </div>
  )
}

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  loadingInitialData: state.application.loadingInitialData,
  language: state.application.appParameters.language,
  appParameters: state.application.appParameters,
})

const mapDispatchToState = (dispatch) => ({
  setMissionActionHandler: (missionCodes) => dispatch(setMissionAction(missionCodes)),
  removeLastShapeActionHandler: () => dispatch(removeLastShapeAction()),
  convertLastShapeToPolygonType: () => dispatch(convertLastShapeToPolygonTypeAction()),
  // @Mapitaly: ALEX implementazione di multimission in corso
  setMultiMissionActionHandler: (missionCodes) => dispatch(setMultiMissionAction(missionCodes))
})

export default connect(mapStateToProps, mapDispatchToState)(MissionField)
